import "styled-components";

const defaultTheme = {
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/lines.png") no-repeat center center,
    url("${process.env.PUBLIC_URL}/assets/images/background/a-hand-with-a-feather.png") no-repeat center center,
    url("${process.env.PUBLIC_URL}/assets/images/background/typewriter.png") no-repeat center center,
    radial-gradient(circle at center in hsl shorter hue, #3d3926, #10100f);`,
  },
  header: {
    fontColor: "#e2c198",
    // backgroundColor: "#191918",
    background: `linear-gradient(to right, transparent, 	rgba(25,	25,	24, 0.9), transparent)`,
  },
  footer: {
    fontColor: "#c98c69",
  },
  switcher: {
    background: `linear-gradient(to right, transparent, #191918, transparent)`,
    headerBackgroundColor: "#191918",
    bodyBackgroundColor: "#3d3926",
    hoverColor: "#b76641",
    fontColor: "#e2c198",
    buttonFontColor: "#756740",
  },
  calendar: {
    backgroundColors: {
      emptyCell: "#1e211a",
      mainCell: "#433d2f",
      dayOfWeekCell: "#433d2f",
      today: "#908566",
    },
    fontColors: {
      main: "#e2c198",
      empty: "#343730",
      day: "#e2c198",
      sunday: "#b76641",
    },
  },
};

export default defaultTheme;
